import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { BULK_ASSIGN_TO_CHANNEL_MEMBER } from "../../../graphql/mutations";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import { TEAM_ROLE } from "../../../variable";
import ChannelTeamMembers from "../../channel-team/channel-team-members";
import { useToastContext } from "../../shared/ToastContext";
import { useSelectRowsCtx } from "../SelectRowsProvider";

function BulkUpdateChannelMember({ open, onClose }) {
    const { toggleToast, setNotify } = useToastContext();
    const { ids, onCompleted } = useSelectRowsCtx();

    const [state, setState] = useReducer(reducerFn, {
        channelMemberIDs: [],
    });

    const [assignToChannelMember, { loading }] = useMutation(
        BULK_ASSIGN_TO_CHANNEL_MEMBER,
        {
            onCompleted: () => {
                setNotify({ msg: "Update Channel Member success", err: false });
                onCompleted && onCompleted();
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        setNotify({ msg: null, err: false });
        toggleToast(true);

        assignToChannelMember({
            variables: {
                memberIDs: state.channelMemberIDs,
                storeIDs: ids,
            },
        });
    }, [
        assignToChannelMember,
        ids,
        state.channelMemberIDs,
        setNotify,
        toggleToast,
    ]);

    const handleStateChange = React.useCallback((value, id) => {
        setState({ [id]: value });
    }, []);

    return (
        <Modal
            title="Update Channel Member"
            sectioned
            open={open}
            onClose={onClose}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <ChannelTeamMembers
                label="Channel Members"
                value={state.channelMemberIDs}
                onChange={(value) =>
                    handleStateChange(value, "channelMemberIDs")
                }
                roles={[
                    TEAM_ROLE.ChannelLeader,
                    TEAM_ROLE.ChannelIdea,
                    TEAM_ROLE.ChannelSeller,
                    TEAM_ROLE.ChannelSupportLeader,
                    TEAM_ROLE.ChannelSupporter,
                ]}
            />
        </Modal>
    );
}

export default BulkUpdateChannelMember;
